import { KeyInfo, Property } from '../../types/property';

export interface KeyInfoCell extends KeyInfo {
  epcRows?: KeyInfo[];
}

const EPC_KEYS = ['EPC_RATING_CHART', 'EPC_RATING', 'EPC_FILES'];

const groupKeyInfo = (keyInfo: Property['keyInfo']): KeyInfoCell[] => {
  let cells: KeyInfoCell[] = [];

  if (keyInfo) {
    cells = keyInfo.filter((row) => !EPC_KEYS.includes(row.key));
    const epcFiles = keyInfo.filter((info) => EPC_KEYS.includes(info.key));
    const index = keyInfo.findIndex((info) => EPC_KEYS.includes(info.key));

    if (epcFiles.length > 0) {
      const epcRow: KeyInfoCell = {
        key: 'EPC',
        image: null,
        link: null,
        name: 'EPC',
        subtext: '',
        text: '',
        textHtml: '',
        epcRows: epcFiles,
      };

      cells.splice(index, 0, epcRow);
    }
  }

  return cells;
};

export default groupKeyInfo;
